import { CheckCircleIcon } from "@heroicons/react/outline";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { type OfflineTaskUpload } from "~/config/offline-storage/offlineTaskUploads.store";
import { Box } from "~/design-system/Box";
import { Inline } from "~/design-system/Inline";
import { Text } from "~/design-system/Text";

interface CompletedUploadsSectionProps {
  completedUploads: OfflineTaskUpload[];
}

export const CompletedUploadsSection: React.FC<
  CompletedUploadsSectionProps
> = ({ completedUploads }) => {
  const { t } = useTranslation();

  if (completedUploads.length === 0) {
    return null;
  }

  return (
    <Box>
      <Inline space="xsmall" alignY="center">
        <CheckCircleIcon
          height={16}
          width={16}
          style={{ color: "var(--colors-positive500)" }}
        />
        <Text size="small" tone="positive" weight="medium">
          {t("Completed")} ({completedUploads.length})
        </Text>
      </Inline>
    </Box>
  );
};
